import { compose, branch, renderNothing } from 'recompose';
import { connect } from 'react-redux';
import WithApplePayQuery from '../../hoc/WithApplePayQuery';
import ApplePay from '../components/ApplePay';
import { getIsKrwnZazzPlaceSteFoyShop } from '../../shops/selectors';

export default compose(
  WithApplePayQuery,
  connect((state, ownProps) => ({
    processing: state.reservation.get('paymentProcessing'),
    isKrwnZazzPlaceSteFoyShop: getIsKrwnZazzPlaceSteFoyShop(state, ownProps.params.shopRoute),
  })),
  branch(
    props => !props.withApplePay || props.isKrwnZazzPlaceSteFoyShop,
    renderNothing,
  ),
)(ApplePay);



// WEBPACK FOOTER //
// ./src/app/reservation/containers/ApplePay.js